import { loadStripe } from "@stripe/stripe-js/pure";
import type { Stripe } from "@stripe/stripe-js";


const MAX_ATTEMPTS = 3;
const BACKOFF_MS = [300, 900];

let cached: Promise<Stripe | null> | null = null;

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

async function attempt(publishableKey: string, i: number): Promise<Stripe | null> {
  try {
    return await loadStripe(publishableKey);
  } catch (error) {
    if (i + 1 >= MAX_ATTEMPTS) throw error;
    await sleep(BACKOFF_MS[i] ?? 900);
    return attempt(publishableKey, i + 1);
  }
}

export function loadStripeWithRetry(
  publishableKey: string | undefined,
): Promise<Stripe | null> {
  if (!publishableKey) return Promise.resolve(null);
  if (cached) return cached;

  cached = attempt(publishableKey, 0).catch((error) => {
    cached = null;
    throw error;
  });
  return cached;
}

export function resetStripeLoaderCache(): void {
  cached = null;
}
